import Brand from "~/components/brand";
import Links, { LinkItem } from "./links";
import MobileMenu, { MobileMenuItem } from "./mobile_menu";
import Toolbar from "./toolbar";
import MenuBar from "./menubar";
import HeaderRoot from "./header";

const HeaderUI = Object.assign(HeaderRoot, {
  Brand,
  LinkItem,
  Links,
  MobileMenu,
  MobileMenuItem,
  Toolbar,
  MenuBar,
});

export default HeaderUI;
